import { Button } from "@mui/material";
import { Link } from "react-router-dom";

import { ProficiencyFeedback } from "api/memberPortal/proficiencyFeedback/proficiencyFeedback.types";
import { Product } from "api/memberPortal/project/product/product.types";
import { useAuth } from "hooks/useAuth";

import {
  canCreateProficiencyFeedbackForm,
  canViewFeedbackButton,
  canViewProficiencyFeedbackForm,
} from "../utils";

interface HeaderProficiencyFeedbackButtonsProps {
  product: Product;
  feedbackForm: ProficiencyFeedback;
  isSubmitted: boolean;
  onClick: () => void;
  filesExist: boolean;
}

const HeaderProficiencyFeedbackButtons = ({
  product,
  feedbackForm,
  isSubmitted,
}: HeaderProficiencyFeedbackButtonsProps) => {
  const { permissions } = useAuth();
  if (!canViewFeedbackButton(permissions)) {
    return null;
  }

  if (canCreateProficiencyFeedbackForm(product, permissions, isSubmitted)) {
    return (
      <Button
        variant={!isSubmitted ? "outlined" : "contained"}
        color="success"
        component={Link}
        to="proficiency-feedback"
      >
        Proficiency Feedback Form
      </Button>
    );
  } else if (
    canViewProficiencyFeedbackForm(feedbackForm, permissions, isSubmitted)
  ) {
    return (
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="proficiency-feedback"
      >
        View Proficiency Feedback Form
      </Button>
    );
  }
  return null;
};

export default HeaderProficiencyFeedbackButtons;
